<div class="inner-content" *ngIf="equipmentTemp.pdesc">
    <ion-card>
        <ion-item>
            <ion-label>
                <h4>Plant: {{equipmentTemp.pdesc}}</h4>
                <!--                <h4>{{equipment.description}}</h4>-->
            </ion-label>
        </ion-item>
        <ion-item>
            <ion-label position="floating"><h4>Description</h4></ion-label>
            <ion-input [(ngModel)]="equipmentTemp.description" [disabled]="overrideDescriptionAllowed.set !== 1"></ion-input>
        </ion-item>
        <ion-item *ngIf="equipmentTemp.reg">
            <ion-label>Reg: {{equipmentTemp.reg}}</ion-label>
        </ion-item>
        <ion-item>
            <ion-label>Weekly:</ion-label>
            <ion-input type="number" [(ngModel)]="equipmentTemp.weeklyRate" (click)="$event.target.select()"
                       (ionChange)="calculatePrice()"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label>Discount, %:</ion-label>
            <ion-input [(ngModel)]="equipmentTemp.discount" (ionChange)="calculatePrice()" type="number"
                       (click)="$event.target.select()"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label class="ion-text-wrap">New Weekly Rate: {{ equipmentTemp.total }}</ion-label>
        </ion-item>
        <ion-item class="ion-align-items-center"
                  *ngIf="equipmentTemp.typ === 'M' || equipmentTemp.typ === 'P'">
            <ion-label>Qty:</ion-label>
            <ion-input [(ngModel)]="equipmentTemp.qty" type="number"></ion-input>
        </ion-item>

        <ion-item (click)="selectDate(1)">
            <ion-label>From Date:</ion-label>
            <ion-label class="ion-text-end">{{ equipmentTemp.fromDate | date: 'dd/MM/yyyy HH:mm' }}</ion-label>
            <ion-icon slot="end" name="calendar"></ion-icon>
        </ion-item>

        <ion-item (click)="selectDate(2)">
            <ion-label>To Date:</ion-label>
            <ion-label class="ion-text-end">{{ equipmentTemp.toDate | date: 'dd/MM/yyyy HH:mm' }}</ion-label>
            <ion-icon slot="end" name="calendar"></ion-icon>
        </ion-item>
        <ion-textarea placeholder="Enter a comment here" [(ngModel)]="equipmentTemp.comment"></ion-textarea>
    </ion-card>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (tap)="addEquipment()" color="success" size="small">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
    <ion-fab vertical="top" horizontal="end" slot="fixed">
        <ion-fab-button (tap)="modalController.dismiss()" color="danger" size="small">
            <ion-icon name="close"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</div>

<div class="inner-content" *ngIf="equipmentTemp.plu">
    <ion-card>
        <ion-item>
            <ion-label class="ion-text-center">
                <h3>Plu: {{equipmentTemp.plu}}</h3>
            </ion-label>
        </ion-item>
        <ion-item>
            <ion-label position="floating"><h4>Description</h4></ion-label>
            <ion-input [(ngModel)]="equipmentTemp.comment"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label>Qty:</ion-label>
            <ion-input [(ngModel)]="equipmentTemp.qty" type="number" (ionChange)="calculatePrice()"
                       (click)="$event.target.select()"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label>Price:</ion-label>
            <ion-input [(ngModel)]="equipmentTemp.weeklyRate" type="number"
                       (ionChange)="calculatePrice()"
                       (click)="$event.target.select()"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label>Discount, %:</ion-label>
            <ion-input type="number" [(ngModel)]="equipmentTemp.discount" (ionChange)="calculatePrice()"
                       (click)="$event.target.select()"></ion-input>
        </ion-item>
        <ion-item>
            <ion-label>Total Price: {{ equipmentTemp.total }} </ion-label>
        </ion-item>
        <!--        <ion-list *ngIf="equipmentTemp.ptSerialBeans">-->
        <!--            <ion-list-header *ngIf="product.ptSerialBeans.length > 0">Serials:</ion-list-header>-->
        <!--            <ion-item (click)="editPTSerials()">-->
        <!--                <ion-label>-->
        <!--                    <p  *ngFor="let ptSerial of product.ptSerialBeans">{{ptSerial.serialNo}}<br></p>-->
        <!--                </ion-label>-->
        <!--            </ion-item>-->
        <!--        </ion-list>-->
    </ion-card>
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (tap)="addEquipment()" color="success" size="small">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
    <ion-fab vertical="top" horizontal="end" slot="fixed">
        <ion-fab-button (tap)="modalController.dismiss()" color="danger" size="small">
            <ion-icon name="close"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</div>
